<template>
  <hic-list-page :entities="entities" :condition="condition" @load="query" :loading="meta.loading" :title="isEmbed ? '' : '生命体征'" hide-keyword hide-search-dialog>
    <template slot="buttons">
      <el-button @click="add" type="primary" size="small" icon="el-icon-plus">新建</el-button>
      <el-button @click="print('体征')" type="warning" size="small" icon="el-icon-printer">体征监测单</el-button>
      <el-button @click="print('血糖')" type="warning" size="small" icon="el-icon-printer">血糖监测单</el-button>
    </template>
    <template slot="search">
      <el-date-picker @change="dateChange" v-model="meta.dateRange" style="width: 270px" size="small" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" placeholder="开单日期"></el-date-picker>
      <el-button @click="query" type="info" plain size="small" icon="el-icon-search" class="left-pad">查询</el-button>
    </template>
    <el-table-column v-if="!readonly" label="操作 " key="action" align="center" width="150">
      <template #default="{ row }">
        <el-button type="primary" size="mini" icon="el-icon-edit" circle plain @click="edit(row)" title="编辑" />
        <el-button type="warning" size="mini" icon="el-icon-copy-document" circle plain @click="copy(row)" title="复制" />
        <el-popconfirm title="确定要删除记录吗？" @confirm="remove(row)" class="left-pad">
          <el-button slot="reference" type="danger" size="mini" icon="el-icon-delete" circle plain title="删除" />
        </el-popconfirm>
      </template>
    </el-table-column>
    <el-table-column label="日期" prop="execTime" key="date" align="right" width="100">
      <template #default="{ row }">
        <span>{{ row.execTime | fmtDate }}</span>
      </template>
    </el-table-column>
    <el-table-column label="时间" prop="execTime" key="time" align="left" width="100">
      <template #default="{ row }">
        <span>{{ row.execTime | fmtTime }}</span>
      </template>
    </el-table-column>
    <el-table-column label="体温" prop="temperature" key="temperature" align="right">
      <template #default="{ row }">
        <span v-if="row.temperature">{{ row.temperature }} <span class="info">℃</span></span>
      </template>
    </el-table-column>
    <el-table-column label="脉搏" prop="pulse" key="pulse" align="right">
      <template #default="{ row }">
        <span v-if="row.pulse">{{ row.pulse }} <span class="info">次/分</span></span>
      </template>
    </el-table-column>
    <el-table-column label="呼吸" prop="respiration" key="respiration" align="right">
      <template #default="{ row }">
        <span v-if="row.respiration"> {{ row.respiration }} <span class="info">次/分</span></span>
      </template>
    </el-table-column>
    <el-table-column label="血压" prop="bloodPressure" key="bloodPressure" align="right">
      <template #default="{ row }">
        <span v-if="row.bloodPressure">{{ row.bloodPressure }} <span class="info">mmHg</span></span>
      </template>
    </el-table-column>
    <el-table-column label="血糖" prop="bloodGlucose" key="bloodGlucose" align="right">
      <template #default="{ row }">
        <span v-if="row.bloodGlucose">{{ row.bloodGlucose }} <span class="info">mmol/L</span></span>
      </template>
    </el-table-column>

    <el-table-column label="护士" prop="nurseName" key="nurseName" align="center" />
    <el-table-column label="特殊原因" prop="reason" key="reason">
      <template #default="{ row }">
        <span class="danger">{{ row.reason | dictText("VitalSignReason") }}</span>
      </template>
    </el-table-column>
    <el-table-column label="备注" prop="memo" key="memo" show-overflow-tooltip />

    <Editor :visible.sync="meta.showEdit" v-model="curr" @saved="query" />
    <Creater :visible.sync="meta.showCreate" :patients="patients" @saved="query" />

    <PrintDialog :visible.sync="meta.showPrint" :hospitalization="entity" :type="meta.printType" />
  </hic-list-page>
</template>
<script>
import api from "./api";
import { mapGetters } from "sw-hic";
export default {
  props: {
    entity: Object, // 住院记录
  },
  components: {
    Editor: () => import("./vitalSign/edit"),
    Creater: () => import("./vitalSign/create"),
    PrintDialog: () => import("./dlgPrint"),
  },
  data() {
    return {
      meta: {
        loading: false,
        date: null,
        dateRange: [],
        showEdit: false,
        showCreate: false,
        showPrint: false,
        printType: null,
      },
      condition: {
        sort: "id",
        asc: false,
        ids: [],
        pageSize: 20,
        pageIndexOnView: 1,
      },
      entities: {},
      patients: [],
      curr: {},
    };
  },
  computed: {
    ...mapGetters(["dict", , "Enum", "dictEnum", "user"]),
    isEmbed() {
      // 是否是嵌入模式
      return this.$route.path != "/vitalSign";
    },
    readonly() {
      return this.entity?.state == "已离院" || this.entity?.state == "已结算";
    },
    currPatient() {
      if (this.entity) {
        return this.entity;
      }
      if (this.condition.ids.length == 1) {
        return this.patients.find((e) => e.id == this.condition.ids[0]);
      }
      return null;
    },
  },
  watch: {
    entity() {
      this.query();
    },
  },
  mounted() {
    this.query();
  },
  methods: {
    dateChange(v) {
      if (v) {
        if (Array.isArray(v)) {
          this.condition.execTimeStart = this.$utils.Fmt.startDatetime(v[0]);
          this.condition.execTimeEnd = this.$utils.Fmt.endDatetime(v[1]);
        } else {
          this.condition.execTimeStart = this.$utils.Fmt.startDatetime(v);
          this.condition.execTimeEnd = this.$utils.Fmt.endDatetime(v);
        }
      } else {
        this.condition.execTimeStart = null;
        this.condition.execTimeEnd = null;
      }
      this.query();
    },
    query() {
      this.meta.loading = true;
      this.condition.deptCode = this.user.deptCode;
      if (this.entity) {
        this.condition.hospitalizationId = this.entity.id;
      }
      api.VitalSigns.query(this.condition)
        .then((res) => {
          this.$set(this, "entities", res);
        })
        .finally(() => {
          this.meta.loading = false;
        });
    },
    print(type) {
      this.meta.printType = type;
      this.meta.showPrint = true;
    },
    add() {
        if (!this.isEmbed) {
          this.meta.showCreate = true;
          return;
        }
        if (!this.entity) {
          this.$message.warning("请选择住院记录");
          return;
        }
        this.curr = {
          ipNo: this.entity.ipNo,
          hospitalizationId: this.entity.id,
          deptCode: this.entity.deptCode,
          wardCode: this.entity.wardCode,
          bedNo: this.entity.bedNo,
          patientCode: this.entity.patientCode,
          patientName: this.entity.patientName,
          execTime: this.$utils.Dt.now(),
        };
        this.meta.showEdit = true;
      },
      edit(row) {
        this.curr = this.$utils.Obj.clone(row);
        this.meta.showEdit = true;
      },
      remove(row) {
        api.VitalSigns.del(row.id).then((res) => {
          this.$message.success("删除成功");
          this.query();
        });
      },
      copy(row) {
        this.curr = this.$utils.Obj.clone(row);
        this.curr.id = null;
        this.curr.lockKey = null;
        this.curr.memo = null;
        this.execTime = this.$utils.Dt.now();
        this.meta.showEdit = true;
      },
  },
};
</script>
